export default function TextureLayer() {
  return <div className="noise-overlay" />;
}